import { Clock } from "lucide-react";
import { useSiteTime } from "../lib/time";

/**
 * Compact header chip that surfaces the app's canonical timezone.
 * Renders "CDT / CST · Central" on md+, just the abbreviation on mobile.
 * Hidden if the app's timezone matches the user's own browser zone (no
 * ambiguity to communicate in that case).
 */
export default function TimezoneChip() {
  const { tz, tzShort, siteTz, usingLocal } = useSiteTime();
  let userTz = "";
  try { userTz = Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch { /* ignore */ }
  // Hide the chip only when the site's canonical tz already matches the user's browser
  // AND they haven't opted into local mode (nothing to communicate).
  if (!usingLocal && userTz && userTz === tz) return null;

  const friendly = tz.split("/").pop().replace("_", " ");
  const title = usingLocal
    ? `Your local timezone (${tz}). App default is ${siteTz}.`
    : `App times shown in ${tz} — your browser is ${userTz || "unknown"}`;
  return (
    <div
      className="hidden sm:inline-flex items-center gap-1.5 border border-slate-200 bg-slate-50 px-2 py-1 font-mono-num text-[10px] uppercase tracking-widest text-slate-500"
      title={title}
      data-testid="header-tz-chip"
    >
      <Clock className="w-3 h-3 text-[#0D9488]" />
      <span className="text-[#0D9488]">{tzShort || "TZ"}</span>
      <span className="text-slate-400">·</span>
      <span>{friendly}</span>
      {usingLocal && <span className="text-slate-400 ml-1">· local</span>}
    </div>
  );
}
